import apiClient from '../../../api/apiClient';

export const getDashboardStatsApi = async (oemId, month) => {
  const response = await apiClient.get(`/partners/oem-partners/dashboard/data?oemId=${oemId}&month=${month}`);
  return response.data.response;
};

export const getMonthlyScanStatsApi = async (oemId) => {
  const response = await apiClient.get(`/partners/oem-partners/monthly-scan-stats/chart?oemId=${oemId}`);
  return response.data.response;
};